// SPDX-License-Identifier: Apache-2.0

import React from "react";
import { BrowserProvider } from "ethers";

export interface State {
  provider: BrowserProvider;
  accounts: string[];
  setAccounts: (addresses: string[]) => void;
}

export const AppContext = React.createContext({} as State);
